import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { InvestigationTypeRepository } from '../../../infrastructure/repositories/investigation-type.repository';
import { InvestigationTypeState } from '../../states/investigation-type.state';
import { GetInvestigationTypeByIdQuery } from './get-investigation-type-by-id.query';
import { GetInvestigationTypeByIdResult } from './get-investigation-type-by-id.result';

@Injectable({ providedIn: 'root' })
export class GetInvestigationTypeByIdUseCase {
  private readonly _repository = inject(InvestigationTypeRepository);
  private readonly _state = inject(InvestigationTypeState);

  public execute(query: GetInvestigationTypeByIdQuery): Observable<GetInvestigationTypeByIdResult> {
    this._state.setLoading(true);
    this._state.clearError();

    return this._repository.getInvestigationTypeById(query.id).pipe(
      tap((investigationType) => {
        this._state.setCurrentInvestigationType(investigationType);
        this._state.setLoading(false);
      }),
      map((investigationType) => ({ investigationType })),
      catchError((error) => {
        const errorMessage =
          error?.error?.message || error?.message || 'Failed to load investigation type';
        this._state.setError(errorMessage);
        this._state.setLoading(false);
        throw error;
      }),
    );
  }
}
